import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function PageHero({ eyebrow, title, subtitle, breadcrumb }) {
  return (
    <section className="relative pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden mesh-bg text-white">
      <div className="absolute inset-0 dot-pattern opacity-40" />
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-violet-500/20 rounded-full blur-3xl animate-pulse-slow" />
      <div className="absolute -bottom-40 -right-32 w-96 h-96 bg-fuchsia-500/20 rounded-full blur-3xl animate-pulse-slow" />

      <div className="relative container-x text-center max-w-4xl mx-auto">
        {breadcrumb && (
          <nav className="flex items-center justify-center gap-2 text-xs text-violet-100/70 mb-6">
            <Link to="/" className="hover:text-violet-300">Home</Link>
            <ChevronRight size={12} />
            <span className="text-violet-300">{breadcrumb}</span>
          </nav>
        )}
        {eyebrow && <span className="eyebrow-dark mb-5">{eyebrow}</span>}
        <h1 className="mt-5 text-4xl md:text-6xl font-extrabold tracking-tight leading-[1.05]">{title}</h1>
        {subtitle && (
          <p className="mt-6 text-lg md:text-xl text-violet-50/80 leading-relaxed max-w-2xl mx-auto">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
